import { delay, http, HttpResponse } from 'msw';

const mockFetchPurchaseExtraSuggestedTruckers = [
  http.post(`${process.env.BFF_URL}pay-per-use/extra-suggested-truckers`, async () => {
    await delay(1500);

    return new HttpResponse(null, { status: 200 });
  }),
];

export { mockFetchPurchaseExtraSuggestedTruckers };
